/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var refreshCart = window.refreshCart;
var udsolgtString = window.udsolgtString;
var availableString = window.availableString;
var options = Array.from(document.querySelectorAll(".ed_option"));
var _loop = function _loop() {
  var option = _options[_i];
  option.addEventListener("click", function (event) {
    event.preventDefault();
    for (var _i2 = 0, _options2 = options; _i2 < _options2.length; _i2++) {
      var _option = _options2[_i2];
      _option.classList.remove("active");
    }
    var id = this.dataset.id;
    option.classList.add("active");
    var parent = this.closest(".ed_b2b");
    var atc = parent.querySelector(".ed_atc");
    var atcText = atc.querySelector(".add-to-cart__text");
    var available = this.dataset.available;
    if (available == "false") {
      atc.disabled = true;
      atc.style.pointerEvents = "none";
      atc.style.background = "#ccc";
      atcText.textContent = udsolgtString;
      atc.style.width = "100%";
    } else {
      atc.disabled = false;
      atc.style.pointerEvents = "auto";
      atc.style.background = "linear-gradient(to right, #7AC3A8 60%, #D6DCCE 90%)";
      atcText.textContent = availableString;
      atc.style.color = "#fff";
    }
    atc.dataset.id = id;
  });
};
for (var _i = 0, _options = options; _i < _options.length; _i++) {
  _loop();
}
var atcBtns = Array.from(document.querySelectorAll(".ed_atc"));
for (var _i3 = 0, _atcBtns = atcBtns; _i3 < _atcBtns.length; _i3++) {
  var btn = _atcBtns[_i3];
  btn.addEventListener("click", function (event) {
    event.preventDefault();
    if (this.dataset.id != "") {
      var parent = this.closest(".ed_b2b");
      var quantity = parent.querySelector(".ed_quantity");
      var quantityVal = quantity.value;
      add(this.dataset.id, quantityVal);
    } else {
      alert("Du skal huske at vælge en variant");
    }
  });
}
function add(dataid, quantity) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: dataid,
              quantity: quantity
            })
          });
        case 3:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 12;
            break;
          }
          _context.next = 7;
          return response.json();
        case 7:
          data = _context.sent;
          window.refreshCart();
          document.dispatchEvent(event);
          _context.next = 13;
          break;
        case 12:
          alert("Der er ikke nok på lager");
        case 13:
          _context.next = 18;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          console.error("Error:", _context.t0);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 15]]);
  }));
}
var edtionBtnPrevious = document.querySelector(".edition_previous");
var edtionBtnNext = document.querySelector(".edition_next");
if (edtionBtnPrevious && edtionBtnNext) {
  var updateButtonsState = function updateButtonsState() {
    setTimeout(function () {
      edtionBtnPrevious.classList.toggle("disabled", editionSlider.scrollLeft <= 0);
      edtionBtnNext.classList.toggle("disabled", editionSlider.scrollLeft >= editionSlider.scrollWidth - editionSlider.clientWidth);
    }, 100);
  };
  var calculateScrollDistance = function calculateScrollDistance() {
    // if window size is less than 768px, set scrollLeftDistance to 1/2 of the editionSlider width
    if (window.innerWidth < 400) {
      return 300;
    } else if (window.innerWidth >= 400 && window.innerWidth < 768) {
      return 250;
    } else if (window.innerWidth >= 768) {
      return 130;
    }
  }; // Define the scrollLeftDistance by dividing the width of the editionSlider by 3
  var editionSlider = document.querySelector(".ed-collection-buttons-master-wrapper");
  editionSlider.addEventListener("scroll", updateButtonsState);
  var scrollLeftDistance = calculateScrollDistance();
  window.addEventListener("resize", function () {
    scrollLeftDistance = calculateScrollDistance();
  });
  edtionBtnPrevious.addEventListener("click", function (event) {
    event.preventDefault();
    editionSlider.scrollLeft -= scrollLeftDistance;
    updateButtonsState();
  });
  edtionBtnNext.addEventListener("click", function (event) {
    event.preventDefault();
    editionSlider.scrollLeft += scrollLeftDistance;
    updateButtonsState();
  });
  updateButtonsState(); // Initial state check
}
var editionQuickAddBtns = Array.from(document.querySelectorAll(".edition_quick_add"));
if (editionQuickAddBtns.length >= 1) {
  editionQuickAddBtns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var closestParent, variantParent, selectedVariant, id;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              closestParent = btn.closest(".product-item");
              variantParent = closestParent.querySelector(".product-options__strength");
              selectedVariant = variantParent ? variantParent.querySelector("a.selected-variant") : null;
              if (btn.dataset.id) {
                editionQuickAdd(btn.dataset.id, 1);
              } else {
                if (selectedVariant) {
                  id = selectedVariant.dataset.id;
                  editionQuickAdd(id, 1);
                } else {
                  variantParent.classList.add("variants-visible");
                }
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    });
  });
}
var upsellPopup = document.querySelector("#upsell-popup");
var variantSelectWrappers = Array.from(upsellPopup.querySelectorAll(".product-options__strength"));
variantSelectWrappers.forEach(function (wrapper) {
  var aTags = Array.from(wrapper.querySelectorAll("a"));
  aTags.forEach(function (a) {
    a.addEventListener("click", function (event) {
      event.preventDefault();
      var closestParent = this.closest(".product-item");
      var quickAddBtn = closestParent.querySelector(".edition_quick_add");
      quickAddBtn.classList.remove("disabled");
      quickAddBtn.disabled = false;
      var textEle = quickAddBtn.querySelector(".add-to-cart__text");
      textEle.textContent = "Læg i kurv";
      var selectedVariant = wrapper.querySelector("a.selected-variant");
      if (selectedVariant) {
        selectedVariant.classList.remove("selected-variant");
      }
      this.classList.add("selected-variant");
    });
  });
});
function editionQuickAdd(id, quantity) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id,
              quantity: quantity
            })
          });
        case 3:
          response = _context3.sent;
          if (!response.ok) {
            _context3.next = 11;
            break;
          }
          _context3.next = 7;
          return response.json();
        case 7:
          data = _context3.sent;
          window.refreshCart();
          _context3.next = 12;
          break;
        case 11:
          alert("Der er ikke nok på lager");
        case 12:
          _context3.next = 17;
          break;
        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](0);
          console.error("Error:", _context3.t0);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 14]]);
  }));
}
var UpsellPopup = /*#__PURE__*/function (_HTMLElement) {
  function UpsellPopup() {
    var _this;
    _classCallCheck(this, UpsellPopup);
    _this = _callSuper(this, UpsellPopup);
    _this.modalBox = _this.querySelector("modal-box");
    _this.openPopup = _this.openPopup.bind(_this);
    return _this;
  }
  _inherits(UpsellPopup, _HTMLElement);
  return _createClass(UpsellPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var closeBtn = this.querySelector(".popup-close");
      closeBtn.addEventListener("click", this.closePopup.bind(this));
      var atcs = Array.from(this.querySelectorAll(".edition_quick_add"));
      atcs.forEach(function (atc) {
        atc.addEventListener("click", function () {
          setTimeout(function () {
            _this2.updateCounter();
          }, 1000);
        });
      });
      var checkoutBtn = document.getElementById("CheckOut");
      checkoutBtn.addEventListener("click", function (event) {
        event.preventDefault();
        setTimeout(function () {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            var totalCount;
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.getCart();
                case 2:
                  totalCount = _context4.sent;
                  if (totalCount > 0 && totalCount < 3) {
                    this.openPopup();
                  } else {
                    window.location.href = "/checkout";
                  }
                case 4:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, this);
          }));
        }, 750);
      });
      document.addEventListener("editionCheckoutStart", function (event) {
        setTimeout(function () {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            var totalCount;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.getCart();
                case 2:
                  totalCount = _context5.sent;
                  console.log("totalCount", totalCount);
                  if (totalCount > 0 && totalCount < 3) {
                    this.openPopup();
                  } else {
                    window.location.href = "/checkout";
                  }
                case 5:
                case "end":
                  return _context5.stop();
              }
            }, _callee5, this);
          }));
        }, 750);
      });
    }
  }, {
    key: "openPopup",
    value: function openPopup() {
      this.modalBox.classList.add("active");
      this.updateCounter();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.modalBox.classList.remove("active");
      window.location.href = "/checkout";
    }
  }, {
    key: "updateCounter",
    value: function updateCounter() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var totalCount, counter;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.getCart();
            case 2:
              totalCount = _context6.sent;
              if (totalCount < 3) {
                counter = this.querySelector("#remaining_count");
                counter.textContent = "".concat(3 - totalCount);
              } else if (totalCount >= 3) {
                this.closePopup();
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getCart",
    value: function getCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var response, data, cartItems, glasses, count;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return fetch("/cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 3:
              response = _context7.sent;
              if (!response.ok) {
                _context7.next = 13;
                break;
              }
              _context7.next = 7;
              return response.json();
            case 7:
              data = _context7.sent;
              cartItems = data.items;
              glasses = cartItems.filter(function (item) {
                return item.product_type.includes("riller");
              });
              count = 0;
              if (glasses.length >= 1) {
                glasses.forEach(function (glass) {
                  count += glass.quantity;
                });
              }
              return _context7.abrupt("return", count);
            case 13:
              _context7.next = 18;
              break;
            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](0);
              console.error("Error:", _context7.t0);
            case 18:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 15]]);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("upsell-popup", UpsellPopup);

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {

function getExpectedDeliveryDates() {
  var today = new Date();
  var deliveryDate;
  var dayOfWeek = today.getDay();
  var extraDaysMondayOne = window.extraDaysMondayOne;
  var extraDaysMondayTwo = window.extraDaysMondayTwo;
  var extraDaysTuesdayOne = window.extraDaysTuesdayOne;
  var extraDaysTuesdayTwo = window.extraDaysTuesdayTwo;
  var extraDaysWednesdayOne = window.extraDaysWednesdayOne;
  var extraDaysWednesdayTwo = window.extraDaysWednesdayTwo;
  var extraDaysThursdayOne = window.extraDaysThursdayOne;
  var extraDaysThursdayTwo = window.extraDaysThursdayTwo;
  var extraDaysFridayOne = window.extraDaysFridayOne;
  var extraDaysFridayTwo = window.extraDaysFridayTwo;
  var extraDaysSaturday = window.extraDaysSaturday;
  var extraDaysSunday = window.extraDaysSunday;
  switch (dayOfWeek) {
    case 1:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysMondayOne * 24 * 60 * 60 * 1000);
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysMondayTwo * 24 * 60 * 60 * 1000);
      }
      break;
    case 2:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysTuesdayOne * 24 * 60 * 60 * 1000);
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysTuesdayTwo * 24 * 60 * 60 * 1000);
      }
      break;
    case 3:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysWednesdayOne * 24 * 60 * 60 * 1000);
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysWednesdayTwo * 24 * 60 * 60 * 1000);
      }
      break;
    case 4:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysThursdayOne * 24 * 60 * 60 * 1000);
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysThursdayTwo * 24 * 60 * 60 * 1000);
      }
      break;
    case 5:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysFridayOne * 24 * 60 * 60 * 1000);
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysFridayTwo * 24 * 60 * 60 * 1000);
      }
      break;
    case 6:
      deliveryDate = new Date(today.getTime() + extraDaysSaturday * 24 * 60 * 60 * 1000);
      break;
    case 0:
      deliveryDate = new Date(today.getTime() + extraDaysSunday * 24 * 60 * 60 * 1000);
      break;
    default:
      break;
  }
  var options = {
    day: "numeric",
    month: "long"
  };
  /*
  const earliestDeliveryStr = earliestDeliveryDate.toLocaleDateString(window.theme.lang, options)
  const latestDeliveryStr = latestDeliveryDate.toLocaleDateString(window.theme.lang, options)
  */
  var deliveryStr = deliveryDate.toLocaleDateString(window.lang, options);
  var deliveryText = window.expectedDeliveryText;
  return "".concat(deliveryText, " ").concat(deliveryStr);
}
var expectedDeliveryEleWrapper = document.getElementById("expected_delivery");
if (expectedDeliveryEleWrapper) {
  var p = expectedDeliveryEleWrapper.querySelector("p");
  if (p) {
    p.innerHTML = getExpectedDeliveryDates();
  }
}

/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkojeojedk"] = self["webpackChunkojeojedk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;